import { WSService } from "../../../../utils/WSService";

export const meridioPlanEnrollmentService = new WSService(
  "/v2/benefits/meridio/plan-enrollment"
);
